<div class="w-full">
  <p class="mx-auto mt-3 w-1/2 text-center font-bold">Unable to find that page</p>
</div>
